<template>
    <path d="M3 3L17 17" stroke="#00AF41" stroke-width="2"></path>
    <path d="M17 3L3 17" stroke="#00AF41" stroke-width="2"></path>
</template>

<script>
    export default {
        name: 'icon-deny'
    }
</script>